const TYPES = {
    TYPE_DIET: 1,
    TYPE_MEDICATION: 3,
    TYPE_SERVICE: 5, // outpatient service
    TYPE_VACCINE: 6, // IMMUNIZATION
    TYPE_LAB: 7,
    TYPE_OTHER_FEES: 11,
    TYPE_DISCOUNT: 12,
    TYPE_OTHER_MEDICAL: 13,
    TYPE_ANESTHESIA: 14,
    TYPE_INPATIENT: 16, // HOSPITALIZATION
    TYPE_DENTISTRY: 15,
    TYPE_RADIOLOGY: 17, // Diagnostic Imaging
    TYPE_SURGERY: 18,
    TYPE_NON_MEDICAL: 19,
    TYPE_GROOMING: 20,
    TYPE_BOARDING: 21,
    TYPE_ACCILLARY: 23,
    TYPE_MORTUARY: 22,
    TYPE_PROFESSIONAL_SERVICE: 24,
    TYPE_EQUIPMENT: 25
};

const DISCOUNT_TYPES = {
    DISCOUNT_TYPE_PERCENTAGE: 0,
    DISCOUNT_TYPE_PRICE: 1
};

const ICONS = [];
ICONS[TYPES.TYPE_OTHER_FEES] = "cus-money";
ICONS[TYPES.TYPE_ACCILLARY] = "cus-attach";
ICONS[TYPES.TYPE_ANESTHESIA] = "cus-clock";
ICONS[TYPES.TYPE_BOARDING] = "cus-house";
ICONS[TYPES.TYPE_DENTISTRY] = "cus-dentistry";
ICONS[TYPES.TYPE_RADIOLOGY] = "cus-radiology";
ICONS[TYPES.TYPE_DIET] = "cus-package";
ICONS[TYPES.TYPE_GROOMING] = "cus-cut";
ICONS[TYPES.TYPE_INPATIENT] = "cus-stethoscope";
ICONS[TYPES.TYPE_VACCINE] = "cus-shield";
ICONS[TYPES.TYPE_LAB] = "cus-clipboard";
ICONS[TYPES.TYPE_MORTUARY] = "cus-heart";
ICONS[TYPES.TYPE_OTHER_MEDICAL] = "cus-paste-plain";
ICONS[TYPES.TYPE_NON_MEDICAL] = "cus-folder";
ICONS[TYPES.TYPE_SERVICE] = "cus-door-out";
ICONS[TYPES.TYPE_MEDICATION] = "cus-pill";
ICONS[TYPES.TYPE_PROFESSIONAL_SERVICE] = "cus-user-gray";
ICONS[TYPES.TYPE_SURGERY] = "cus-monitor";
ICONS[TYPES.TYPE_EQUIPMENT] = "cus-drive";


export default {
    TYPES,
    ICONS,
    DISCOUNT_TYPES
};
